import Spinner from 'react-bootstrap/Spinner';
import '../../assets/css/LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className='spinner__wrap'>
      <Spinner animation="border" role="status"></Spinner>
    </div>
  )
}

export default LoadingSpinner
